import { baseEngaugeAssistant } from "../config";
import axios from "axios";
import { msalInstance } from "src/lib/msal";
import zod, { z } from "zod";
const engaugeAssistantApiInstance = axios.create({
    baseURL: baseEngaugeAssistant,
});

engaugeAssistantApiInstance.interceptors.request.use(
    async (config) => {
        const account = msalInstance.getAllAccounts()[0];
        if (account) {
            const { accessToken } = await msalInstance.acquireTokenSilent({
                scopes: ["User.Read"],
                account: account,
            });

            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);

const employeeSchema = zod.object({
    FirstName: zod.string().nullable(),
    LastName: zod.string().nullable(),
    EmailPersonal: zod.string().nullable(),
});

const employeeResponseSchema = zod.discriminatedUnion("status", [
    zod.object({
        status: z.literal("ok"),
        data: employeeSchema,
    }),
    zod.object({
        status: z.literal("error"),
        message: zod.string(),
    }),
]);

export type ValidatedEmployee = z.infer<typeof employeeSchema>;

async function getEmployee(input: { params: { employeeCode: string } }) {
    const response = await engaugeAssistantApiInstance.get(
        `/GetEmployee/${input.params.employeeCode}`,
    );

    const validatedResponse = employeeResponseSchema.parse(response.data);

    if (validatedResponse.status === "error") {
        throw new Error(validatedResponse.message);
    }

    return validatedResponse.data;
}

export const engaugeAssistantApi = {
    getEmployee,
};
